import { captureException } from '@sentry/react';
import { find, get } from 'lodash';
import { useMemo } from 'react';
import { useCurrentClass } from 'store/classes/selectors';

export const useStudentHaveDiff = ({ assignment, studentId }) => {
  const currentClass = useCurrentClass();
  const assignmentData = useMemo(() => {
    return assignment;
  }, [assignment]);

  const studentHaveDiffOnAssignment = useMemo(() => {
    try {
      if (!assignmentData || !currentClass) return false;
      const classConfig = find(assignmentData?.classes, ['id', get(currentClass, 'id')]);
      const { diff } = classConfig;
      if (!diff) return false;
      const checkStudentHaveInDiff = Array.isArray(diff.groups) && diff.groups.some((group) => group.student.includes(studentId));
      return checkStudentHaveInDiff;
    } catch (error) {
      // captureException(`Error in useStudentHaveDiff: ${error?.message}`);
      return false;
    }
  }, [assignmentData, studentId, currentClass]);

  return { studentHaveDiffOnAssignment };
};
